import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as YoutubeIcon } from '@/assets/icons/youtube-icon.svg';
import { ActionsDropdownButton } from '@/components/ActionsDropdown';
import { RootState } from '@/utils/store';

interface Props {
  channelId: number;
  provider: 'google' | 'facebook';
  isCompetitorChannel?: boolean;
}

const YoutubeIconHolder = styled.span`
  flex-shrink: 0;
  filter: grayscale(1);
  opacity: 0.6;
  transition: all ease-out 0.2s;
  svg {
    margin-left: 6px;
    margin-right: 0;
    max-width: none;
  }
`;

const StyledActionsDropdownButton = styled(ActionsDropdownButton)`
  &:hover {
    ${YoutubeIconHolder} {
      filter: grayscale(0);
      opacity: 1;
    }
  }
`;

const AUTHORIZED_EMAILS = [
  'bpsmediaanalytics@boredpanda.com',
  'marius.k@boredpanda.com',
  'andrius.sadauskas@digitalaz.com',
  'loreta.z@boredpanda.com',
  'edita.z@boredpanda.com',
];

const AuthorizationButton: FC<Props> = ({
  channelId,
  provider,
  isCompetitorChannel = false,
}) => {
  const isYtOwner = useSelector(
    (rootState: RootState) =>
      process.env.REACT_APP_ENVIRONMENT === 'development' ||
      AUTHORIZED_EMAILS.includes(rootState.auth.user!.email),
  );

  const location = useLocation();

  if (!isYtOwner) return null;

  return (
    <StyledActionsDropdownButton
      as="a"
      href={`${
        process.env.REACT_APP_API_ENDPOINT
      }/socialite/${provider}?channel_id=${channelId}&redirect_path=${encodeURIComponent(
        location.pathname,
      )}`}
    >
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={22}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
          />
        </svg>
      </span>
      {!!isCompetitorChannel ? (
        'Authorize'
      ) : provider === 'facebook' ? (
        'Authorize'
      ) : (
        <>
          Authorize with{' '}
          <YoutubeIconHolder>
            <YoutubeIcon />
          </YoutubeIconHolder>
        </>
      )}
    </StyledActionsDropdownButton>
  );
};

export default AuthorizationButton;
